export const DIMENSIONS = [
    'customer_movement_type',
    'customer_movement_type_detailed_key',
    'barcode',
    'brand_desc',
    'brand_type_desc',
    'class_desc',
    'class_key',
    'department_key',
    'department_desc',
    'grp_class_key',
    'grp_class_desc',
    'main_holding_desc',
    'main_holding_key',
    'bem_merchandise_key',
    'bem_merchandise_desc',
    'supplier_root_key',
    'supplier_root_desc',
    'supplier_key',
    'supplier_desc',
    'store_chain_type_desc',
    'store_chain_type_key',
    'sub_class_desc',
    'sub_class_key',
    'item_key',
    'item_desc',
    'store_key',
    'store_desc',
    'store_region_desc',
    'assort_key',
    'ch_typo_key',
    'activity_type',
    'store_int_flag_desc',
    'bcp_chain_desc',
    'supplier_root_desc_anonymized',
    'competitor_desc_anonymized',
    'brand_desc_anonymized',
    'barcode_anonymized',
    'item_key_anonymized',
    'item_desc_anonymized',
    'business_brand',
    'business_brand_reduced',
    'trad_consostyle_macro_desc',
    'trad_consostyle_micro_desc',
    'trad_lifestage_macro_desc',
    'trad_lifestage_micro_desc',
    'date_key_evolution_date',
    'date_key_evolution_month',
    'date_key_evolution_week'
];
//# sourceMappingURL=dimensions.constant.js.map